/* eslint-disable */
export default {
  419: '拉丁美洲',
  AR: '阿根廷',
  AT: '奧地利',
  AU: '澳洲',
  BE: '比利時',
  BG: '保加利亞',
  BH: '巴林',
  BJ: '貝南',
  BR: '巴西',
  CA: '加拿大',
  CH: '瑞士',
  CL: '智利',
  CN: '中國',
  CO: '哥倫比亞',
  CY: '賽普勒斯',
  CZ: '捷克共和國',
  DE: '德國',
  DK: '丹麥',
  DO: '多明尼加共和國',
  EE: '愛沙尼亞',
  ES: '西班牙',
  FI: '芬蘭',
  FR: '法國',
  GB: '英國',
  GE: '喬治亞',
  GH: '迦納',
  GN: '幾內亞',
  GR: '希臘',
  HK: '香港',
  HR: '克羅埃西亞',
  HU: '匈牙利',
  ID: '印尼',
  IE: '愛爾蘭',
  IL: '以色列',
  IN: '印度',
  IT: '義大利',
  JP: '日本',
  KE: '肯亞',
  KR: '南韓',
  LT: '立陶宛',
  LU: '盧森堡',
  LV: '拉脫維亞',
  MX: '墨西哥',
  MY: '馬來西亞',
  NG: '奈及利亞',
  NL: '荷蘭',
  NO: '挪威',
  NZ: '紐西蘭',
  PA: '巴拿馬',
  PE: '秘魯',
  PH: '菲律賓',
  PK: '巴基斯坦',
  PL: '波蘭',
  PR: '波多黎各',
  PT: '葡萄牙',
  RO: '羅馬尼亞',
  SE: '瑞典',
  SG: '新加坡',
  SI: '斯洛維尼亞',
  SK: '斯洛伐克',
  SV: '薩爾瓦多',
  TR: '土耳其',
  TW: '台灣',
  UA: '烏克蘭',
  US: '美國',
  VN: '越南',
  ZA: '南非',
} as const;

// @key: @#@"419"@#@ @source: @#@"Latin America"@#@
// @key: @#@"AR"@#@ @source: @#@"Argentina"@#@
// @key: @#@"AT"@#@ @source: @#@"Austria"@#@
// @key: @#@"AU"@#@ @source: @#@"Australia"@#@
// @key: @#@"BE"@#@ @source: @#@"Belgium"@#@
// @key: @#@"BG"@#@ @source: @#@"Bulgaria"@#@
// @key: @#@"BH"@#@ @source: @#@"Bahrain"@#@
// @key: @#@"BJ"@#@ @source: @#@"Benin"@#@
// @key: @#@"BR"@#@ @source: @#@"Brazil"@#@
// @key: @#@"CA"@#@ @source: @#@"Canada"@#@
// @key: @#@"CH"@#@ @source: @#@"Switzerland"@#@
// @key: @#@"CL"@#@ @source: @#@"Chile"@#@
// @key: @#@"CN"@#@ @source: @#@"China"@#@
// @key: @#@"CO"@#@ @source: @#@"Colombia"@#@
// @key: @#@"CY"@#@ @source: @#@"Cyprus"@#@
// @key: @#@"CZ"@#@ @source: @#@"Czech Republic"@#@
// @key: @#@"DE"@#@ @source: @#@"Germany"@#@
// @key: @#@"DK"@#@ @source: @#@"Denmark"@#@
// @key: @#@"DO"@#@ @source: @#@"Dominican Republic"@#@
// @key: @#@"EE"@#@ @source: @#@"Estonia"@#@
// @key: @#@"ES"@#@ @source: @#@"Spain"@#@
// @key: @#@"FI"@#@ @source: @#@"Finland"@#@
// @key: @#@"FR"@#@ @source: @#@"France"@#@
// @key: @#@"GB"@#@ @source: @#@"United Kingdom"@#@
// @key: @#@"GE"@#@ @source: @#@"Georgia"@#@
// @key: @#@"GH"@#@ @source: @#@"Ghana"@#@
// @key: @#@"GN"@#@ @source: @#@"Guinea"@#@
// @key: @#@"GR"@#@ @source: @#@"Greece"@#@
// @key: @#@"HK"@#@ @source: @#@"Hong Kong"@#@
// @key: @#@"HR"@#@ @source: @#@"Croatia"@#@
// @key: @#@"HU"@#@ @source: @#@"Hungary"@#@
// @key: @#@"ID"@#@ @source: @#@"Indonesia"@#@
// @key: @#@"IE"@#@ @source: @#@"Ireland"@#@
// @key: @#@"IL"@#@ @source: @#@"Israel"@#@
// @key: @#@"IN"@#@ @source: @#@"India"@#@
// @key: @#@"IT"@#@ @source: @#@"Italy"@#@
// @key: @#@"JP"@#@ @source: @#@"Japan"@#@
// @key: @#@"KE"@#@ @source: @#@"Kenya"@#@
// @key: @#@"KR"@#@ @source: @#@"South Korea"@#@
// @key: @#@"LT"@#@ @source: @#@"Lithuania"@#@
// @key: @#@"LU"@#@ @source: @#@"Luxembourg"@#@
// @key: @#@"LV"@#@ @source: @#@"Latvia"@#@
// @key: @#@"MX"@#@ @source: @#@"Mexico"@#@
// @key: @#@"MY"@#@ @source: @#@"Malaysia"@#@
// @key: @#@"NG"@#@ @source: @#@"Nigeria"@#@
// @key: @#@"NL"@#@ @source: @#@"Netherlands"@#@
// @key: @#@"NO"@#@ @source: @#@"Norway"@#@
// @key: @#@"NZ"@#@ @source: @#@"New Zealand"@#@
// @key: @#@"PA"@#@ @source: @#@"Panama"@#@
// @key: @#@"PE"@#@ @source: @#@"Peru"@#@
// @key: @#@"PH"@#@ @source: @#@"Philippines"@#@
// @key: @#@"PK"@#@ @source: @#@"Pakistan"@#@
// @key: @#@"PL"@#@ @source: @#@"Poland"@#@
// @key: @#@"PR"@#@ @source: @#@"Puerto Rico"@#@
// @key: @#@"PT"@#@ @source: @#@"Portugal"@#@
// @key: @#@"RO"@#@ @source: @#@"Romania"@#@
// @key: @#@"SE"@#@ @source: @#@"Sweden"@#@
// @key: @#@"SG"@#@ @source: @#@"Singapore"@#@
// @key: @#@"SI"@#@ @source: @#@"Slovenia"@#@
// @key: @#@"SK"@#@ @source: @#@"Slovakia"@#@
// @key: @#@"SV"@#@ @source: @#@"El Salvador"@#@
// @key: @#@"TR"@#@ @source: @#@"Türkiye"@#@
// @key: @#@"TW"@#@ @source: @#@"Taiwan"@#@
// @key: @#@"UA"@#@ @source: @#@"Ukraine"@#@
// @key: @#@"US"@#@ @source: @#@"United States"@#@
// @key: @#@"VN"@#@ @source: @#@"Vietnam"@#@
// @key: @#@"ZA"@#@ @source: @#@"South Africa"@#@
